import React, { useContext } from 'react';
import Block from '@legacy-vfuk/core-block';
import RichTextElement from '../../Elements/RichText';
import { SectionPromotionBandProps } from './types/SectionPromotionBand.types';
import {
  BlockWrapper,
  whiteCSS,
  galleryCSS,
  ContainerWrapper,
  ContentWrapper,
  ImageWrapper,
} from './styles/SectionPromotionBand.styles';
import { DirectionContext } from '../../../../contexts/DirectionContext';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';

const SectionPromotionBand = ({
  content,
  mainImage,
  backgroundColor,
  imageAlignment,
}: SectionPromotionBandProps) => {
  const direction = useContext(DirectionContext);
  const backgroundCss = backgroundColor === 'white' ? whiteCSS : galleryCSS;
  const isImageLeft = imageAlignment === 'left' || direction === 'rtl';

  const theContent = content?.map(item => {
    return (
      <RichTextElement
        key={item.id}
        rawRichText={item.text.raw}
        color={item.color}
        textAlign={item.textAlign}
      />
    );
  });

  return (
    <BlockWrapper>
      <Block css={backgroundCss}>
        <ContainerWrapper
          isImageLeft={isImageLeft}
          data-testid="section-promotion-band-container"
        >
          <ContentWrapper isImageLeft={isImageLeft}>
            {theContent}
          </ContentWrapper>
          <ImageWrapper>
            <GatsbyImage
              image={getImage(mainImage) as IGatsbyImageData}
              alt={mainImage.description}
            />
          </ImageWrapper>
        </ContainerWrapper>
      </Block>
    </BlockWrapper>
  );
};

export default SectionPromotionBand;
